<template>
  <div class="text-center">
    <h3>{{ $t('auth.common.notAuthorized') }}</h3>
    <p>{{ $t('global.auth.noPermission', 'You do not have permission to access this page.') }}</p>
    <p>
      {{ $t('global.auth.pleaseLogInThrough') }}
      <a href="https://carrier.opendock.com">{{ $t('global.specialtyTerms.opendock') }}</a>
    </p>
  </div>
</template>

<script>
export default {};
</script>
